<template>
  <div class="qyh_public_menu" >
    <el-divider content-position="left">公众号菜单栏</el-divider>
    <el-row type="flex">
      <div class="menu__preview">
        <div class="menu__preview-hd">
          <p class="wechat_name">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ activeName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="企业火">企业火</el-dropdown-item>
                <el-dropdown-item command="账伙伴">账伙伴</el-dropdown-item>
                <el-dropdown-item command="账66">账66</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </p>
        </div>
        <div class="menu__preview-bd">
          <div class="menu__preview-bottom">
            <div class="menu__keyboard">
              <div class="menu__keyboard-icon"></div>
            </div>
            <div class="menu__edit-add">
              <div class="menu__list-wrap">
                <li v-for="(item, index) in menu.button" :key="index"  class="pre_menu_item size1of3" :class="active === index && activeType === 'button' ? 'active-line' : ''" @click="selMenu(index)">
                  <span class="link_span menu__menu_link">{{ item.name }}</span>
                  <div class="menu__preview-line line__no-menu"></div>
                  <div class="sub_pre_menu_box menu__sub-menu-box js_l2TitleBox" v-if="active === index">
                    <ul class="sub__pre-menu-list">
                      <li class="jslevel2" v-for="(subButton, idx) in item.sub_button" :key="idx" :class="(subActive === idx && activeType === 'subButton') ? 'active-line-sub' : ''" @click.stop="selSubMenu($event, idx)">
                        <span class="menu__menu_sub_link">{{subButton.name}}</span>
                      </li>
                      <li v-if="item.sub_button.length < 5" @click.stop="addSubButton"><span><i class="el-icon-plus"></i>添加</span></li>
                    </ul>
                    <i class="arrow arrow_out"></i>
                    <i class="arrow arrow_in"></i>
                  </div>
                </li>
                <li v-if="menu.button && menu.button.length < 3"  class="pre_menu_item size1of3" @click="addButton"><i style="font-size: 20px; width: auto; overflow: hidden; margin-top: 16px" class="el-icon-plus"></i></li>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="menu__right_container">
        <div v-if="menu.button && menu.button.length > 0" class="menu__content">
          <div>
            <h3>菜单信息</h3>
            <div class="menu__form-container">
              <!--  -->
              <div>
                <div class="weui-desktop-form__control-group">
                  <label class="from-label">名称</label>
                  <div class="weui-desktop-form__controls">
                    <el-input v-model="activeData.name" size="small" @change="menuNameChange"></el-input>
                    <p class="from-p">仅支持中英文和数字，字数不超过{{ activeType === 'button' ? 4 : 8 }}个汉字或{{ activeType === 'button' ? 8 : 16 }}个字母。</p>
                    <!-- <p v-if="nameError" style="color: #FA5151; padding-top: 8px">字数超过上限</p> -->
                  </div>
                </div>
              </div>
              <!-- / -->
              <!-- content -->
              <div v-if="(menu.button[active].sub_button.length !== 0 && activeType === 'subButton') || (activeType === 'button' && menu.button[active].sub_button.length === 0)">
                <div>
                  <div class="weui-desktop-form__control-group">
                    <label class="from-label">消息类型</label>
                    <div class="weui-desktop-form__controls menu__radio-wrap">
                      <el-radio-group v-model="activeData.type" @change="activeDataTypeChange">
                        <!-- <el-radio label="text">发送消息</el-radio> -->
                        <el-radio label="view">跳转网页</el-radio>
                        <el-radio label="miniprogram">跳转小程序</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
                <!-- / -->
                <!--  -->
                <div v-if="activeData.type === 'view'">
                  <div class="weui-desktop-form__control-group">
                    <label class="from-label">网页链接</label>
                    <div class="weui-desktop-form__controls">
                      <el-input v-model="activeData.url" size="small"></el-input>
                      <!-- <p class="from-p">从已发表选择 从页面模版选择</p> -->
                    </div>
                  </div>
                </div>
                <!-- / -->
                <!--  -->
                <div v-if="activeData.type === 'miniprogram'">
                  <div class="weui-desktop-form__control-group">
                    <label class="from-label">小程序</label>
                    <div class="weui-desktop-form__controls menu__radio-wrap">
                      <span><img src="/static/wxapp.svg"></span>
                      <span>企业火</span>
                    </div>
                  </div>
                  <div class="weui-desktop-form__control-group">
                    <label class="from-label">路径</label>
                    <div class="weui-desktop-form__controls">
                      <el-input v-model="activeData.pagepath" size="small"></el-input>
                      <p class="from-p">用户点击此菜单会跳转到当前路径的小程序</p>
                      <p v-if="!this.activeData.pagepath && this.activeData.type === 'miniprogram'" style="color: #FA5151; padding-top: 8px">小程序路径不能为空</p>
                    </div>
                  </div>
                </div>
                <!-- / -->
              </div>
              <!-- / -->
            </div>
          </div>
          <div class="menu__delete-menu"><span @click="delMenu">删除菜单</span></div>
        </div>
        <div v-else class="menu__content">你未添加自定义菜单，点击左侧添加菜单为公众号创建菜单栏。</div>
        <div class="menu__edit-action-bar">
          <el-button type="primary" size="small" @click="subFrom">保存并发布</el-button>
        </div>
      </div>

    </el-row>
  </div>
</template>

<script>
export default {
  name: 'QyhPublicMenu',
  data () {
    return {
      activeName: '企业火',
      active: 0,
      subActive: 0,
      activeType: 'button',
      activeData: {
        name: '',
        type: 'view',
        url: '',
        appid: '',
        pagepath: '',
        sub_button: []
      },
      menu: [],
      subData: {
        name: '',
        radio: 1,
        view: ''
      }
    }
  },
  methods: {
    getMenu() {
      this.$axios.get('/api/admin/wx_public_menu?name=' + this.activeName)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.menu = data.data.menu
            console.log(this.menu)
            this.activeData = this.menu.button[this.active]
          }
        })
    },
    handleCommand (command) {
      this.activeName = command
      // this.active = 0
      // this.activeType = 'button'
      this.selMenu(0)
      this.getMenu()
    },
    selMenu (index) {
      this.active = index
      this.activeType = 'button'
      if (this.menu.button.length > 0) {
        this.activeData = this.menu.button[this.active]
        this.menuNameChange(this.activeData.name)
      }
    },
    selSubMenu (event, index) {
      this.activeType = 'subButton'
      this.subActive = index
      this.activeData = this.menu.button[this.active].sub_button[this.subActive]
      this.menuNameChange(this.activeData.name)
      event.stopPropagation()
    },
    addButton () {
      let activeData = {
          name: '菜单名称',
          type: 'view',
          url: '',
          appid: '',
          pagepath: '',
          sub_button: []
      }
      this.menu.button.push(activeData)
      this.selMenu(this.menu.button.length - 1)
    },
    addSubButton (event) {
      this.activeType = 'subButton'
      let activeData = {
          name: '子菜单',
          type: 'view',
          url: '',
          appid: '',
          pagepath: '',
          sub_button: []
      }
      this.menu.button[this.active].sub_button.push(activeData)
      this.subActive = this.menu.button[this.active].sub_button.length - 1
      this.activeData = this.menu.button[this.active].sub_button[this.subActive]
      this.refreshButton()

      event.stopPropagation()
    },
    refreshButton () {
      this.menu.button[this.active].url = ''
      this.menu.button[this.active].type = 'view'
      this.menu.button[this.active].pagepath = ''
      this.menu.button[this.active].appid = ''
    },
    delMenu () {
      let name = ''
      if (this.activeType === 'button') {
        name = this.menu.button[this.active].name
      } else {
        name = this.menu.button[this.active].sub_button[this.subActive].name
      }
      let msg = '删除后，'+ name +'菜单下设置的内容全部将被删除'
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.activeType === 'button' ? this.delButton() : this.delSubButton()
      }).catch(() => {})
    },
    delSubButton () {
      this.menu.button[this.active].sub_button.splice(this.subActive, 1)
      if (this.menu.button[this.active].sub_button.length === 0) {
        this.selMenu(this.active)
        return
      }

      if (this.subActive >= this.menu.button[this.active].sub_button.length) {
        --this.subActive
      }

      this.activeData = this.menu.button[this.active].sub_button[this.subActive]
    },
    delButton () {
      this.menu.button.splice(this.active, 1)
      console.log(this.menu)
      if (this.menu.button.length === 0) {
        this.active = 0
        return
      }
      this.selMenu(this.active === 0 ? this.active : --this.active)
    },
    subFrom () {
      // return;
      this.$confirm('发布成功后会覆盖原版本，且将在24小时内对所有用户生效，确认发布？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmSubForm()
      }).catch(() => {})
    },
    checkParams () {
      console.log(this.menu)
      for (var i = 0; i < this.menu.button.length; i++) {
        if (this.menu.button[i].type === 'miniprogram' && !this.menu.button[i].pagepath) {
          return false
        }

        for (var j = 0; j < this.menu.button[i].sub_button.length; j++) {
          if (this.menu.button[i].sub_button[j].type === 'miniprogram' && !this.menu.button[i].sub_button[j].pagepath) {
            return false
          }
        }

      }
      return true
    },
    confirmSubForm () {
      let check = this.checkParams()
      if (!check) {
        return this.$message.error('请修改错误后再提交')
      }
      
      this.$axios.post('/api/admin/wx_public_menu', {menu: this.menu, name: this.activeName})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    activeDataTypeChange (value) {
      if (value === 'view') {
        this.activeData.pagepath = ''
        this.activeData.appid = ''
      }

      if (value === 'miniprogram') {
        this.activeData.appid = 'wx2e099145ad81d7b6'
        this.activeData.url = ''
      }
      console.log(value)
    },
    menuNameChange (value) {
      if (this.activeType === 'button') {
        this.activeData.name = this.nameCheckOne(value)
        console.log(this.activeData)
      }

      if (this.activeType === 'subButton') {
        this.activeData.name = this.nameCheckTwo(value)
      }
    },
    nameCheckOne (value) {
      const regex = /^[\u4e00-\u9fa5]{1,4}$|^[a-zA-Z0-9]{1,8}$/;
      if (!regex.test(value)) {
        return value.slice(0, 4)
      }

      return value
    },
    nameCheckTwo (value) {
      const reg = /^[\u4e00-\u9fa5]{0,4}[a-zA-Z]{0,8}$/;
      if (!reg.test(value)) {
        return value.slice(0, 8)
      }

      return value
    }
  },
  mounted () {
    this.getMenu()
  }
}
</script>

<style lang="stylus" scoped>
.qyh_public_menu {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
.wechat_name {
  position: relative;
  text-align: center;
  top: 52px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.active-line .menu__menu_link {
  color: #409EFF;
}
.active-line-sub {
  border: 1px solid #409EFF;
  color: #409EFF;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.sub_pre_menu_box {
  position: absolute;
  bottom: 70px;
  left: 0;
  width: 100%;
  border: 1px solid #D0D0D0;
}
.arrow {
  position: absolute;
  left: 50%;
  margin-left: -6px;
}
.arrow_out {
  bottom: -6px;
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: dashed;
  border-color: transparent;
  border-bottom-width: 0;
  border-top-color: #D0D0D0;
  border-top-style: solid;
}
.arrow_in {
  bottom: -5px;
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: dashed;
  border-color: transparent;
  border-bottom-width: 0;
  border-top-style: solid;
  border-top-color: #fff;
}
.menu__preview {
  width: 300px;
  border: 1px solid #eee3e3;
  border-radius: 8px;
  margin-right: 24px;
  max-height: 634px;
}
.menu__preview-hd {
  background-image: url(/static/wx_pub_menu_hd.png)
  background-size: cover;
  height: 70px;
}
.menu__preview-bd {
  height: 480px;
  position: relative;
  border-radius: 0 0 8px 8px;
}
.menu__preview-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 68px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  box-shadow: inset 0px 0.5px 0px #e3e4e5;
  -webkit-box-align: center;
  align-items: center;
  border-radius: 0 0 8px 8px;
}
.menu__keyboard {
  width: auto;
  height: 100%;
  padding: 0 2px;
}
.menu__keyboard-icon {
  width: 40px;
  height: 100%;
  background-image: url(/static/sel.svg)
}
.menu__preview-line {
  left: 44px;
}
.line__no-menu {
  position: absolute;
  width: 0.5px;
  height: 33px;
  left: 0;
  bottom: 8px;
  right: 0;
  background-color: #e3e4e5;
}
.menu__edit-add {
  flex: 1;
}
.menu__list-wrap {
  list-style: none;
}
.pre_menu_item {
  position: relative;
  line-height: 48px;
  cursor: pointer;
  float: left;
  text-align: center;
}
.active-line .link_span {
  border: 1px solid #409eff;
}
.active-line .menu__preview-line {
  z-index: -1;
}
.link_span {
  display: block;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.size1of3 {
  width: 33.33%;
}
.pre_menu_item a {
  display: block;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
}
.menu__right_container {
  height: 100%;
  flex: 1;
  border: 1px solid #eee3e3;
}
.menu__content {
  padding: 40px;
}
.menu__form-container {
  margin-top: 32px;
}
.from-label {
  float: left;
  margin: 10px 30px 0 0;
  width: 5em;
}
.from-p {
  padding-top: 8px;
  color: #7e8081;
  font-size: 13px;
}
.weui-desktop-form__control-group {
  display: flex;
  margin-bottom: 32px;
  max-width: 100%;
}
.weui-desktop-form__controls {
  flex: 1;
  width: auto;
}
.menu__radio-wrap {
  margin-top: 8px;
}
.menu__delete-menu {
  margin-top: 40px;
}
.menu__delete-menu span {
  color: #409eff;
  cursor: pointer;
}
.menu__edit-action-bar {
  height: 80px;
  line-height: 80px;
  text-align: right;
  border-top: 1px solid rgba(0,0,0,0.02);
  padding-right: 40px;
  border: 1px solid #eee3e3;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxPublicConfig/QyhPublicMenu.vue